module.exports = __webpack_public_path__ + "img/big6-3.a9738864.jpg";